import MapView from 'esri/views/MapView';
import EsriMap from 'esri/Map';
import SketchViewModel from 'esri/widgets/Sketch/SketchViewModel';
import { AddressType } from 'types';

export type View = MapView;
export type Map = EsriMap;
export type SketchView = SketchViewModel;

export type BaseMapItem = {
  thrumbnailUrl: string;
  id: string;
  label: string;
  theme: string;
  geometry?: __esri.Geometry;
  category: number;
  styleId?: string | null;
  webmapId?: string | null;
  state?: string;
};

export type BaseMapOptions = BaseMapItem[];

export type HexBinClassBreaks = {
  h3_rslt: number;
  p20: number;
  p40: number;
  p60: number;
  p80: number;
};

export interface SetShapePayload {
  shape: GeoJSON.GeometryObject | null | undefined;
  area: number | null | undefined;
}

export interface MapDrawFuncParams {
  graphic: any;
  graphics: any[] | undefined;
  drawingLayer: __esri.GraphicsLayer;
}

export interface MapModules {
  Map: __esri.MapConstructor;
  MapView: __esri.MapViewConstructor;
  Extent: __esri.ExtentConstructor;
  GeometryEngine: __esri.geometryEngine;
  SpatialReference: __esri.SpatialReferenceConstructor;
  WebMercatorUtils: __esri.webMercatorUtils;
  Graphic: __esri.GraphicConstructor;
  GraphicsLayer: __esri.GraphicsLayerConstructor;
  SketchViewModel: __esri.SketchViewModelConstructor;
  FeatureLayer: __esri.FeatureLayerConstructor;
  Config: __esri.Config;
  PortalItem: __esri.PortalItemConstructor;
}

export interface Shape {
  type: string;
  coordinates: [];
  bbox?: [];
}

export interface MapPlaceSuggestionCustomFields {
  locality: string;
  region: string;
  postcode?: string;
}

export interface MapPlaceSuggestion {
  Coordinate: string;
  CustomFields: MapPlaceSuggestionCustomFields;
  Highlight: string;
  Score: string;
  Value: string;
  Extent?: __esri.Extent;
  MagicKey?: string;
  AddressId?: string;
  IsCollection?: boolean;
}

export interface MapGetPlaceSuggestPayload {
  datasets: string;
  query: string;
  fields: string;
  limit: string;
  category?: string;
  location?: any;
}
export interface MapSearchLocationHistoryObject {
  Coordinate: string;
  CustomFields: MapPlaceSuggestionCustomFields;
  scope: string;
  Value: string;
  Extent?: __esri.Extent;
  MagicKey?: string;
  AddressId?: string;
  IsCollection?: boolean;
}
export interface MapSearchLocationHistory {
  [userId: number]: MapSearchLocationHistoryObject[];
}

export interface GeocodeCoordinatePayload {
  datasets: string;
  latitude: string;
  longitude: string;
}

export interface GeocodeType {
  formattedaddress: string;
  locality: string;
  postcode: string;
  region: string;
}

export interface GeoscapeAddress {
  selectedSuggestion?: MapPlaceSuggestion;
  address?: AddressType;
  coordinate?: string;
}

export interface LandParcelType {
  formattedaddress?: string;
  shape: GeoJSON.GeometryObject | string;
  address?: AddressType;
}

export enum MAP_DATA_SERVICE_DATA_SET {
  GEOCODEAU = 'geocodeau',
  GNAF = 'gnaf',
  GNAF_ADDRESS = 'gnaf_address',
  GNAFLPID = 'gnaflpid'
}

export enum MAP_DEFAULT_VAR {
  BASEMAP = 'imageryHybrid' // Changed from webmap ID to config key for consistency
}

interface stateAcronymModel {
  [key: string]: string;
}

export const stateAcronym: stateAcronymModel = {
  'Australian Capital Territory': 'ACT',
  'New South Wales': 'NSW',
  'Northern Territory': 'NT',
  Queensland: 'QLD',
  'South Australia': 'SA',
  Victoria: 'VIC',
  Tasmania: 'TAS',
  'Western Australia': 'WA'
};
